// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles-module--loader--24Erg","spin":"styles-module--spin--2O20U"};